
<div class="login-from-header">
    <span class="logo">
      <app-logo [isLogin]="true"></app-logo>
    </span>
  <h1>Create an account</h1>
  <p>Already have an account? <a [routerLink]="['/user/login']">Log in</a></p>
</div>

@if (!isSuccess) {
  <form [formGroup]="register" (submit)="registerUser()">
    <ion-segment formControlName="accountType">
      <ion-segment-button value="tenant">I'm a tenant</ion-segment-button>
      <ion-segment-button value="landlord">I'm a landlord</ion-segment-button>
    </ion-segment>
    <ion-row class="form-col">
      <ion-col>
        <ion-label>First Name</ion-label>
        <ion-input [errorText]="formTextContent?.formErrorMessages.mandatory"
                   fill="outline" mode="md"
                   formControlName="first_name"
                   placeholder="First Name"></ion-input>
      </ion-col>
      <ion-col>
        <ion-label>Last Name</ion-label>
        <ion-input [errorText]="formTextContent?.formErrorMessages.mandatory"
                   fill="outline" mode="md"
                   formControlName="last_name"
                   placeholder="Last Name"></ion-input>
      </ion-col>
    </ion-row>


    <ion-label>Email</ion-label>
    <ion-input [errorText]="formTextContent?.formErrorMessages.mandatory"
               fill="outline" mode="md"
               [readonly]="isReadOnlyEmail"
               formControlName="email"
               placeholder="Email"></ion-input>

    <app-select-country [userInput]="prefix" (countrySelected)="countrySelected($event)"></app-select-country>
    <ion-label>{{formTextContent?.formLabel.phone}}</ion-label>
    <ion-input [errorText]="formTextContent?.formErrorMessages.mandatory"
               fill="outline" mode="md"
               placeholder="00 000 0000"
               (ionInput)="validateNumber($event)"
               formControlName="phone_number">
      <span slot="start">{{prefix}}</span>
    </ion-input>

    @if (!isReadOnlyEmail) {

      <ion-row class="form-col">
        <ion-col>
          <div class="register-input">
            <ion-label>Password</ion-label>
            <ion-input [errorText]="formTextContent?.formErrorMessages.mandatory"
                       fill="outline" mode="md"
                       formControlName="password"
                       type="password"
                       placeholder="Password"></ion-input>
            @if (register.get('password')?.hasError('passwordStrength') && register.get('password')?.touched) {
              <div class="info">
                <p>Password must contain at least:</p>
                <small>One uppercase letter</small>
                <small>One special character</small>
                <small>One numeric digit</small>
                <small>Minimum 8 characters</small>
              </div>
            }
          </div>
        </ion-col>
        <ion-col>
          <ion-label>Confirm Password</ion-label>
          <ion-input fill="outline" mode="md"
                     [errorText]="register.hasError('passwordMismatch') && register.get('confirm_password')?.touched ? 'Password mismatch' : ''"
                     formControlName="confirm_password"
                     type="password"
                     placeholder="Confirm Password"></ion-input>
        </ion-col>
      </ion-row>
    }
    <ion-button expand="block"
                color="primary" type="submit">Register</ion-button>
  </form>
} @else {
  <div class="login-success">
    <ion-icon name="checkmark-circle-outline"></ion-icon>
    <h1>Congratulations!</h1>
    <p>Your account has been successfully created. You can now log in.</p>
  </div>
}
